var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoneyWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    color: "white",
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0742 21.7013H29.081C29.9472 21.7013 30.6655 20.9881 30.6655 20.1168V9.31496C30.6655 8.4429 29.9522 7.73047 29.081 7.73047H11.0742",
    stroke: "currentColor",
    strokeWidth: 1.18879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4304 19.2695H26.6387",
    stroke: "currentColor",
    strokeWidth: 1.18879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4567 19.2695H22.2285",
    stroke: "currentColor",
    strokeWidth: 1.18879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8613 13.6338H30.6649",
    stroke: "currentColor",
    strokeWidth: 1.18879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6649 11.0537H10.8613",
    stroke: "currentColor",
    strokeWidth: 1.18879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2906 26.2764H3.125",
    stroke: "currentColor",
    strokeWidth: 1.18879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6484 5.8916V23.5409",
    stroke: "currentColor",
    strokeWidth: 1.18879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6298 24.0665V28.0303C18.6298 29.2607 17.6992 30.2771 16.5715 30.2771H4.72432C3.59242 30.2771 2.66602 29.2667 2.66602 28.0303V4.24682C2.66602 3.01132 3.59242 2 4.72432 2H14.6609",
    stroke: "currentColor",
    strokeWidth: 1.18879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66602 24.0664V28.0302C2.66602 29.2606 3.59667 30.277 4.72432 30.277H16.5715C17.7034 30.277 18.6298 29.2665 18.6298 28.0302",
    stroke: "currentColor",
    strokeWidth: 1.18879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.63477 2H16.5714C17.7033 2 18.6297 3.01047 18.6297 4.24682V5.6411",
    stroke: "currentColor",
    strokeWidth: 1.18879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9.35156 28.1426H11.944",
    stroke: "currentColor",
    strokeWidth: 1.18879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyWhite);
export default __webpack_public_path__ + "static/media/money-white.5b7f66d9dcb3bd2523f595b3d3587280.svg";
export { ForwardRef as ReactComponent };